export default async (to, from, next) => {
  next();
}



// WEBPACK FOOTER //
// ./src/middlewares/listener.js